<!--
 * @Author: luxian luxian@micous.com
 * @Date: 2024-09-27 17:41:54
 * @LastEditors: luxian luxian@micous.com
 * @LastEditTime: 2024-12-21 16:58:19
 * @Description:
 * @version:
-->
<template>
  <div class="box">
    <vue-clock-picker
      :disabled="disabled"
      clearable
      :placeholder="childPlaceholder"
      class="time-sty"
      cancel-text="取消"
      done-text="确定"
      v-model="valueTime"
      @beforeClose="beforeClose"
    ></vue-clock-picker>

    <i
      class="el-icon-circle-close anniu"
      @click="clean"
      style="float: right;"
    ></i>
  </div>
</template>

<script>
import VueClockPicker from "@pencilpix/vue2-clock-picker";
// import "@pencilpix/vue2-clock-picker/dist/vue2-clock-picker.min.css";
export default {
  name: "timeSelect",
  components: {
    VueClockPicker
  },
  props: {
    timePeriod: {
      type: String,
      default: ""
    },
    childPlaceholder: {
      type: String,
      default: ""
    },
    valueTime: {
      type: String,
      default: ""
    },
    dddd: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // valueTime:""
    };
  },
  methods: {
    beforeClose() {
      this.$emit("startTimeSelect", this.timePeriod, this.valueTime);
    },
    clean() {
      this.$emit("startTimeSelect", this.timePeriod);
    }
  }
};
</script>

<style scoped lang="less">
.time-sty {
  width: 100%;
  height: 100%;
}
.clock-picker_input-container {
  width: 100%;
  height: 100%;
}
/deep/.clock-picker__input {
  border: 1px solid gainsboro;
  width: 100%;
  // height: 100%;
  height: 37px;
  border-radius: 3px;
}
.box {
  position: relative;
}
.anniu {
  position: absolute;
  right: 0;
  bottom: 13px;
}

/deep/.clock-picker__input-container /deep/.clock-picker__input--has-value {
  background: #e4e7ed;
}

.clock-picker__input {
  border: 1px solid gainsboro;
}
.clock-picker__input--error,
.clock-picker__input--error.clock-picker__input--has-value {
  color: #f44336;
}
.clock-picker__input--error .clock-picker__input,
.clock-picker__input--error.clock-picker__input--has-value
  .clock-picker__input {
  border-color: #f44336;
}
.clock-picker__input--has-value .clock-picker__input {
  border-color: #00e676;
}
.clock-picker__button {
  background: none;
  width: 24px;
  height: 24px;
  display: inline-block;
  border: 0;
  border-radius: 12px;
  line-height: 24px;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: #757575;
  font-weight: 500;
  font-size: 13px;
}
.clock-picker__button:hover {
  background-color: #f5f5f5;
}
.clock-picker__button:active {
  background-color: #ededed;
}
.clock-picker__button:focus {
  background-color: #e8e8e8;
}
.clock-picker__button--active,
.clock-picker__button--active:active,
.clock-picker__button--active:hover,
.clock-picker__button--active:focus {
  background-color: #a48bd1;
  color: #fff;
}
.clock-picker__button[disabled] {
  opacity: 0.4 !important;
  cursor: default;
}
.clock-picker__button[disabled],
.clock-picker__button[disabled]:active,
.clock-picker__button[disabled]:hover,
.clock-picker__button[disabled]:focus {
  background-color: #f5f5f5;
  color: #757575;
}

.clock-picker__dialog {
  display: none;
}
.clock-picker__dialog--active {
  display: block;
}
.clock-picker__dialog-drop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 200;
}
.clock-picker__dialog-body {
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  width: 320px;
  margin: -235px -160px;
  background-color: #fff;
  z-index: 201;
  transform: scale(1);
  border-radius: 5px;
  overflow: auto;
}
.clock-picker__dialog-header {
  padding: 1.5rem 1.5rem;
  font-size: 2rem;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.clock-picker__dialog-header span:hover,
.clock-picker__dialog-header span:focus {
  cursor: pointer;
}
.clock-picker__dialog-content {
  position: relative;
  width: 100%;
  height: 280px;
  margin-top: 24px;
  margin-bottom: 24px;
}
.clock-picker__dialog-content .clock-picker__hours,
.clock-picker__dialog-content .clock-picker__minutes {
  position: absolute;
}
.clock-picker__dialog-actions {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: row;
  flex-direction: row;
  border-top: 1px solid #f5f5f5;
  padding: 0.5rem;
}
.clock-picker__dialog-action {
  padding: 0 1rem;
  margin: 0;
  background: transparent;
  border: 0;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;
  font-weight: 500;
  line-height: 32px;
  display: inline-block;
  cursor: pointer;
}
.clock-picker__dialog-action:hover {
  background-color: #f5f5f5;
}
.clock-picker__dialog-action:focus {
  background-color: #ededed;
}
.clock-picker__dialog-action:active {
  background-color: #e6e6e6;
}
.clock-picker__dialog-action[disabled] {
  background-color: #f5f5f5;
  color: #e6e6e6;
}
.clock-picker__dialog-action[disabled]:hover,
.clock-picker__dialog-action[disabled]:focus,
.clock-picker__dialog-action[disabled]:active {
  cursor: not-allowed;
}
.clock-picker__dialog .scale-enter-active,
.clock-picker__dialog .scale-leave-active,
.clock-picker__dialog .fade-enter-active,
.clock-picker__dialog .fade-leave-active {
  transition: all 0.3s ease;
}
.clock-picker__dialog .scale-enter,
.clock-picker__dialog .scale-leave-active {
  opacity: 0;
  transform: scale(0);
}
.clock-picker__dialog .fade-enter,
.clock-picker__dialog .fade-leave-active {
  opacity: 0;
}

.clock-picker__hours {
  position: relative;
  width: 100%;
  height: 280px;
}

.clock-picker__minutes {
  position: relative;
  width: 100%;
  height: 280px;
}
</style>



// WEBPACK FOOTER //
// src/components/timeSelect/index.vue